import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Disclaimer } from './disclaimer.component';
import { OverlayActions } from '../../../../modules/overlay';
import { withKeyboardClose } from '../../../../shared/components/HOC/withKeyboardClose';

const mapStateToProps = createStructuredSelector({});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showPolicy: OverlayActions.showPolicy,
      showTerms: OverlayActions.showTerms,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter,
  withKeyboardClose
)(Disclaimer);
